import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID,
  OnDestroy,
  HostListener,
  AfterViewInit,
  ChangeDetectorRef,
  NgZone,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { LoginComponent } from '../../../components/login/login.component';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { LoaderService } from '../../services/loader.service';
import { AuthService } from '../../services/auth.service';
import { LogoutDetectionService } from '../../services/logout-detection.service';
import { FormsModule } from '@angular/forms';
import { BehaviourSubjectService } from '../../services/behaviour-subject.service';
import { Event as RouterEvent } from '@angular/router';
import { environment } from '../../../../environment/environment';
import { CartService } from '../../services/cart.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, LoginComponent, FormsModule,RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  isMobile: boolean = false;
  showHoverPopup: boolean = false;
  searchTerm = '';
  userData: any;
  showLoginModal = false;
  showSearch: boolean = false;
  isSearch: boolean = false;
  imageUrls: any;

  isModalOpen = false;
  selectedTab: 'usedParts' | 'scrap' | null = null;
  private modalHoverTimeout: any = null;
  isLoggedIn = false;
  userDataLogin: any;
  sub: Subscription = new Subscription();
  user: any;
  userForm: any;

  // Location properties
  userLocation: string = 'Location'; // Default location text
  isLocationLoading: boolean = false;
  locationError: boolean = false;
  productData: any = null;
  currentAction: string = 'other';
  private lastScrollTop = 0;
  private isHome = false;
  environment1 = environment.s3BucketUrl;
  scrapList: any;
  usedList: any;
  showSettingsPanel = false;
  showMoreOptionsDropdown = false;
  cartItemCount: number = 0; // Add cart count property
  isCartCountLoading: boolean = false; // Add loading state for cart count
  
  // Logout confirmation popup
  showLogoutPopup: boolean = false;

  // Search popup properties
  showSearchPopup: boolean = false;
  searchGuideData: any;
  advanceSearchData: any;
  selectedChip: any = null;
  isMobileSearchActive: boolean = false; // Track mobile search input state
  selectedSearchFields: any = {
    make: '',
    model: '',
    year_of_manufacture: '',
    variant: '',
  };
  defaultSearchImage = 'https://cdn.builder.io/api/v1/image/assets/TEMP/b18795cb56f55f03b9aaca888100d5b63db572dc?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  scrapDefaultSearchImage = 'https://cdn.builder.io/api/v1/image/assets/TEMP/3179c3111a162b89731a23e1cfd2428a324601d0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';

  constructor(
    private router: Router,
    private apiService: ApiService,
    private loadService: LoaderService,
    private authService: AuthService,
    private logoutDetectionService: LogoutDetectionService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private behaviourSubject: BehaviourSubjectService,
    private cdref: ChangeDetectorRef,
    private cartService: CartService, // Add CartService
    private ngZone: NgZone
  ) {
    if (isPlatformBrowser(this.platformId)) {
      // Track route changes to toggle scroll behavior
      this.router.events
        .pipe(
          filter(
            (event: RouterEvent): event is NavigationEnd =>
              event instanceof NavigationEnd
          )
        )
        .subscribe((event: NavigationEnd) => {
          const currentUrl = event.urlAfterRedirects;

          this.isHome = currentUrl === '/' || currentUrl.startsWith('/home');

          if (this.isHome) {
            this.checkScrollForSearch(); // Enable scroll-based visibility
          } else {
            this.isSearch = true; // Always show on other pages
          }

          // Refresh cart count when navigating back to header
          if (this.isLoggedIn && (currentUrl === '/' || currentUrl.startsWith('/home'))) {
            this.fetchCartCount();
          }
        });

      // Auth sync across tabs
      window.addEventListener('storage', (event) => {
        if (event.key === 'useractive') {
          setTimeout(() => {
            this.authService.initializeAuthState();
          }, 0);
        }
      });
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadScrapAndUsedParts();
      this.isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) && window.innerWidth < 480;

      this.sub.add(
        this.behaviourSubject.showLoginModal$.subscribe((visible) => {
          this.showLoginModal = visible;
        })
      );

      this.sub.add(
        this.behaviourSubject.loginSource$.subscribe((source) => {
          this.currentAction = source || 'other';
        })
      );

      this.sub.add(
        this.behaviourSubject.productData$.subscribe((data) => {
          this.productData = data;
        })
      );
        // Auto-fetch user location for all visitors
        this.getUserLocation();

        // Subscribe to authentication state changes
      this.sub.add(
        this.authService.isLoggedIn$.subscribe((isLoggedIn) => {
          this.isLoggedIn = isLoggedIn;
          if (isLoggedIn) {
            this.getUserDetails();
              // Location already fetched on page load
          } else {
            this.userData = null;
            this.userDataLogin = null;
            this.user = null;
            // Reset cart count when user logs out
            this.cartService.updateCartCount(0);
          }
        })
      );

      // Subscribe to user data changes
      this.sub.add(
        this.authService.userData$.subscribe((userData) => {
          this.userDataLogin = userData;
          this.userData = userData;
          this.user = userData;
          
          // If we have user data and are logged in, fetch cart count
          if (userData && this.isLoggedIn) {
            this.fetchCartCount();
          }
        })
      );

      // Subscribe to cart count changes
      this.sub.add(
        this.cartService.cartItemCount$.subscribe((count) => {
          this.ngZone.run(() => {
            this.cartItemCount = count;
          });
        })
      );

      // Also listen for cart updates from other components
      this.sub.add(
        this.behaviourSubject.productData$.subscribe((data) => {
          if (data && this.isLoggedIn) {
            // Refresh cart count when product data changes (e.g., after adding to cart)
            setTimeout(() => this.fetchCartCount(), 100);
          }
        })
      );
    }
    //  this.updateSearchVisibility();
  }

  loadScrapAndUsedParts() {
    try {
      const payload = {}; // Provide appropriate payload as required by the API

      this.apiService.get_category(payload).subscribe({
        next: (value) => {
          if (value.success) {
            this.imageUrls = value?.data;

            this.scrapList = value.data.scrap_list;
            this.usedList = value.data.used_list;
          } else {
            console.warn('Customer feedback API returned success: false');
            this.scrapList = [];
            this.usedList = [];
          }
        },
        error: (err) => {
          console.error('Error loading category list:', err);
          this.scrapList = [];
          this.usedList = [];
        },
      });
    } catch (error) {
      console.error('Error in category list:', error);
      this.scrapList = [];
      this.usedList = [];
    }
  }

  // Get user's current location
  getUserLocation(): void {
    if (isPlatformBrowser(this.platformId) && 'geolocation' in navigator) {
      this.isLocationLoading = true;
      this.locationError = false;

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          this.getLocationDetails(latitude, longitude);

          this.cdref.detectChanges();
        },
        (error) => {
          console.error('Error getting location:', error);
          this.isLocationLoading = false;
          this.locationError = true;

          // Handle specific geolocation errors
          switch (error.code) {
            case error.PERMISSION_DENIED:
              break;
            case error.POSITION_UNAVAILABLE:
              break;
            case error.TIMEOUT:
              break;
            default:
              break;
          }

          // Keep default location if geolocation fails
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000, // 5 minutes
        }
      );
    } else {
      this.locationError = true;
    }
  }

  // Get location details from coordinates
  getLocationDetails(latitude: number, longitude: number): void {
    const payload = {
      latitude: latitude,
      longitude: longitude,
    };

    this.sub.add(
      this.apiService.geoLocation(payload).subscribe({
        next: (res) => {
          this.isLocationLoading = false;
          if (res.data.data_by_pincode[0].city_name) {
            this.userLocation = res.data.data_by_pincode[0].city_name;
          } else if (res?.data?.data_by_pincode[0]?.state_name) {
            this.userLocation = res.data.data_by_pincode[0].state_name;
          } else if (res?.data?.data_by_pincode[0]?.pincode) {
            this.userLocation = res.data.data_by_pincode[0].pincode;
          }

          localStorage.setItem(
            'userLocation',
            JSON.stringify(res.data.data_by_pincode[0])
          );
          
          // Trigger change detection to immediately update the UI
          this.cdref.detectChanges();
        },
        error: (err) => {
          console.error('Failed to fetch location details', err);
          this.isLocationLoading = false;
          this.locationError = true;
          // Keep default location if API fails
          this.cdref.detectChanges();
        },
      })
    );
  }

  openPopup() {
    // For both mobile and desktop users, open login modal
    this.showHoverPopup = false;
    this.closeSettingsPanel();
    this.behaviourSubject.openLoginModal('other'); // No product data passed
  }

  closePopup() {
    this.behaviourSubject.closeLoginModal();
    // Refresh auth state to ensure components get the updated login status
    setTimeout(() => {
      this.authService.refreshAuthState();
    }, 100);
  }

  logout(): void {
    this.logoutDetectionService.logoutWithRefresh();
  }

  confirmLogout(): void {
    this.logoutDetectionService.logoutWithRefresh();
    this.showLogoutPopup = false;
  }

  cancelLogout(): void {
    this.showLogoutPopup = false;
  }

  openModal(tab: 'usedParts' | 'scrap') {
    
    // Clear any existing timeout
    if (this.modalHoverTimeout) {
      clearTimeout(this.modalHoverTimeout);
      this.modalHoverTimeout = null;
    }
    
    // If modal is already open for a different tab, switch to the new tab
    if (this.isModalOpen && this.selectedTab !== tab) {
      this.selectedTab = tab;
    } else {
      this.selectedTab = tab;
      this.isModalOpen = true;
    }
  }

  closeModal() {
    // Clear any existing timeout
    if (this.modalHoverTimeout) {
      clearTimeout(this.modalHoverTimeout);
      this.modalHoverTimeout = null;
    }
    
    this.isModalOpen = false;
    this.selectedTab = null;
  }

  onNavMouseLeave() {
    // Add a small delay before closing to allow moving to modal
    this.modalHoverTimeout = setTimeout(() => {
      if (this.isModalOpen) {
        this.closeModal();
      }
    }, 150);
  }

  onModalMouseEnter() {
    // Clear timeout when entering modal area
    if (this.modalHoverTimeout) {
      clearTimeout(this.modalHoverTimeout);
      this.modalHoverTimeout = null;
    }
  }

  onModalMouseLeave() {
    // Close modal when leaving modal area
    this.closeModal();
  }

  onModalContentMouseEnter() {
    // Clear timeout when entering modal content
    if (this.modalHoverTimeout) {
      clearTimeout(this.modalHoverTimeout);
      this.modalHoverTimeout = null;
    }
  }

  onModalContentMouseLeave() {
    // Add delay when leaving modal content
    this.modalHoverTimeout = setTimeout(() => {
      this.closeModal();
    }, 100);
  }

  gotoProductlist(data: any, type?: any) {
    this.closeModal();
    localStorage.removeItem('category');
    localStorage.removeItem('filterState')
    localStorage.removeItem('guideSearchData');
      localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('seemore');
    localStorage.setItem('category', JSON.stringify(data));
    localStorage.removeItem('categoryType');
      localStorage.removeItem('SpareCategory');
    localStorage.removeItem('MyGarageData');

    localStorage.setItem('categoryType', JSON.stringify(type));
    
    // Clear search text when switching categories/part types
    this.behaviourSubject.setSearchTerm('');
    this.behaviourSubject.clearSelectedFilters();
    
    // Check if we're already on the product-list page
    if (this.router.url === '/product-list') {
      // Use behavior subject to notify product-list component
      this.behaviourSubject.setCategoryChanged({ data, type });
    } else {
      this.router.navigate(['/product-list']);
    }
    
    this.closeSettingsPanel()
  }

  gotoHome() {
    this.router.navigate(['/home']);
  }

  navigateToTataMotors() {
    window.open('https://www.tatamotors.com/', '_blank');
  }

  navigateToTata() {
    window.open('https://www.tata.com/', '_blank');
  }

  capitalizeFirstLetter(text: string | undefined): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  gotoNotification() {
    this.router.navigate(['/cart']);
  }

  gotoUserProfile() {
    this.router.navigate(['/user-profile']);
  }

  getUserDetails(): void {
    const payload = {};
    this.loadService.show();
    this.sub.add(
      this.apiService.getUserDetails(payload).subscribe({
        next: (res) => {
          this.userDataLogin = res?.data;
          this.userData = res?.data;
          this.user = res?.data;
          this.loadService.hide();
          
          // After getting user details, fetch cart count
          this.fetchCartCount();
        },
        error: (err) => {
          console.error('Failed to fetch user details', err);
          this.loadService.hide();
        },
      })
    );
  }

  // Method to fetch cart count from API
  fetchCartCount(): void {
    if (this.isLoggedIn) {
      this.isCartCountLoading = true;
      const payload = {
      "offset":0,"limit":100,"action_type":"GET_LIST","get_selected_parts":""
      };
      
      
      this.sub.add(
        this.apiService.getCartData(payload).subscribe({
          next: (res: any) => {
            this.cdref.detectChanges();
            this.isCartCountLoading = false;
            if (res.success && res.data && res.data.cart_items) {
              const count = res.data.cart_items.length;
              this.cartService.updateCartCount(count);
            } else {
              this.cartService.updateCartCount(0);
            }
          },
          error: (err: any) => {
            console.error('Failed to fetch cart count:', err);
            this.isCartCountLoading = false;
          }
        })
      );
    } else {
    }
  }

  onSearchInput(event: any) {
    // Clear previous search fields when new search input starts
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };
    this.selectedChip = null;
    // Clear previous advance search data
    this.advanceSearchData = null;
    // Call advance search with empty fields for fresh search
    this.advanceSearch({
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    });
  }

  onEnterKey(event: any) {
    event.preventDefault();
    this.onSearchTrigger();
  }

  filterProducts(term: string) {
    const trimmedTerm = term.trim();
    if (!trimmedTerm) {
      return;
    }

    // Follow the same pattern as home banner navigation
    localStorage.removeItem('filterState');
    localStorage.removeItem('category');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('mostSearchedModel');

console.log('gotoProductList called with item:', trimmedTerm);


    // Set search data in the same format as home banner
    const searchData = {
      // make: trimmedTerm,
      // model: trimmedTerm,
      // year_of_manufacture: trimmedTerm,
      // variant: trimmedTerm,
      // part_type: trimmedTerm,
      search_text: trimmedTerm,
      part_type: this.advanceSearchData?.suggestions[0]?.part_type ? this.advanceSearchData.suggestions[0].part_type : 'Used Part',


    };
    localStorage.setItem('guideSearchData', JSON.stringify(searchData));
    
    this.behaviourSubject.setSearchTerm(trimmedTerm);

    // Check if we're already on the product-list page
    if (this.router.url === '/product-list' || this.router.url.startsWith('/product-list')) {
      // Use behavior subject to notify product-list component of search change
      // We'll use the existing categoryChanged observable to trigger refresh
      this.behaviourSubject.setCategoryChanged({ search_text: trimmedTerm, isSearch: true });
    } else {
      this.router.navigate(['/product-list']);
    }

    this.searchTerm = '';
    this.showSearchPopup = false;
    this.advanceSearchData = null;
    this.selectedChip = null;
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };
    this.cdref.detectChanges();
  }

  // Search popup methods
  onFocus() {
    this.showSearchPopup = true;
    this.cdref.detectChanges();
    if (!this.searchGuideData) {
      this.getGuideSearchData();
    }
  }

  onBlur() {
    // Optional: Delay to allow clicks inside popup
    setTimeout(() => {
      this.showSearchPopup = false;
      this.cdref.detectChanges();
    }, 200);
  }

  onSearchTrigger() {
    if (this.searchTerm.trim()) {
      this.filterProducts(this.searchTerm);
      // Close mobile search after triggering search
      if (this.isMobileSearchActive) {
        this.closeMobileSearch();
      }
    }
  }

  advanceSearch(fields = this.selectedSearchFields) {
    if (!this.searchTerm.trim()) {
      return;
    }

    const data = {
      make: fields.make || '',
      model: fields.model || '',
      year_of_manufacture: fields.year_of_manufacture || '',
      variant: fields.variant || '',
      part_type: fields.make ? (this.advanceSearchData?.suggestions?.[0]?.part_type || '') : '',
      search_text: this.searchTerm.trim(),
    };

    this.sub.add(
      this.apiService.getadvancePartSearch(data).subscribe({
        next: (value) => {
          if (value.success) {
            this.advanceSearchData = value.data;
            this.showSearchPopup = true;
            this.cdref.detectChanges();
          } else {
            this.advanceSearchData = { smart_fill: [], suggestions: [] };
            this.cdref.detectChanges();
          }
        },
        error: (err) => {
          this.advanceSearchData = { smart_fill: [], suggestions: [] };
        }
      })
    );
  }

  getGuideSearchData() {
    const data = {};
    this.sub.add(
      this.apiService.guideSearch(data).subscribe({
        next: (value) => {
          if (value.success) {
            this.searchGuideData = value.data;
            this.cdref.detectChanges();
          } else {
            this.searchGuideData = null;
            this.cdref.detectChanges();
          }
        },
        error: (err) => {
          this.searchGuideData = null;
        }
      })
    );
  }

  onChipClick(chip: any) {
    this.selectedChip = chip === this.selectedChip ? null : chip;
    this.cdref.detectChanges();
    
    if (chip) {
      // Structure the data from smart_fill chip
      const chipData = {
        make: chip.value || '',
        model: '',
        year_of_manufacture : '',
        variant: '',
        part_type: chip.part_type || ''
      };
      
      // Navigate with chip data
      this.gotoProductList(chipData, chip.part_type);
    }
  }

  onSuggestionClick(suggestion: any) {
    this.cdref.detectChanges();
    
    // Structure the data from suggestion
    const suggestionData = {
      make: suggestion.make || '',
      model: suggestion.model || '',
      year_of_manufacture: suggestion.year || '',
      variant: suggestion.variant || '',
      part_type: suggestion.part_type || ''
    };
    
    // Navigate with suggestion data
    this.gotoProductList(suggestionData, suggestion.part_type);
  }

  gotoProductList(item: any, type: string) {
    // Follow the same pattern as home banner
    localStorage.removeItem('filterState');
    localStorage.removeItem('category');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('mostSearchedModel');
    const searchData = {
      make: item?.make || '',
      model: item?.model || '',
      year_of_manufacture: item?.year_of_manufacture || '',
      variant: item?.variant || '',
      part_type: item?.make ? item?.part_type : ''
    };
    localStorage.setItem('guideSearchData', JSON.stringify(searchData));
    
    // Check if we're already on the product-list page
    if (this.router.url === '/product-list' || this.router.url.startsWith('/product-list')) {
      // Use behavior subject to notify product-list component
      this.behaviourSubject.setCategoryChanged({ ...item, type: type, isItemClick: true });
    } else {
      this.router.navigate(['/product-list']);
    }
     this.searchTerm = '';
    this.showSearchPopup = false;
    this.advanceSearchData = null;
    this.selectedChip = null;
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };
    // Close mobile search when navigating
    if (this.isMobileSearchActive) {
      this.closeMobileSearch();
    }
  }

  seeMoregotoProductList(section: string) {
    // Handle see more navigation
    localStorage.removeItem('filterState');
    localStorage.removeItem('category');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('mostSearchedModel');

    const searchData = section
    localStorage.setItem('seemore', searchData);
    
    // Check if we're already on the product-list page
    if (this.router.url === '/product-list' || this.router.url.startsWith('/product-list')) {
      // Use behavior subject to notify product-list component
      this.behaviourSubject.setCategoryChanged({ section: section, isSeeMore: true });
    } else {
      this.router.navigate(['/product-list']);
    }
    this.showSearchPopup = false;
    this.advanceSearchData = null;
    this.selectedChip = null;
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };
    // Close mobile search when navigating
    if (this.isMobileSearchActive) {
      this.closeMobileSearch();
    }
    this.cdref.detectChanges();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    
    // Clear any pending timeouts
    if (this.modalHoverTimeout) {
      clearTimeout(this.modalHoverTimeout);
      this.modalHoverTimeout = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (!this.isHome) return; // ✅ Disable scroll logic outside /home

    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // ✅ Show on scroll down
    if (scrollTop > 100) {
      this.isSearch = true;
    }
    // ✅ Hide on scroll near top
    else if (scrollTop < 50) {
      this.isSearch = false;
    }

    this.lastScrollTop = scrollTop;
  }

  private checkScrollForSearch(): void {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    this.isSearch = scrollTop > 100 ? true : false;
  }

  toggleSettingsPanel() {
    this.showSettingsPanel = !this.showSettingsPanel;
  }

  closeSettingsPanel() {
    this.showSettingsPanel = false;
  }

  openSection: string | null = null;

  sections = [
    { key: 'used', label: 'Used Parts' },
    { key: 'scrap', label: 'Scrap' },
    { key: 'more', label: 'More Options' },
  ];

  toggleSection(key: string) {
    this.openSection = this.openSection === key ? null : key;
  }

  toggleMoreOptionsDropdown() {
    this.showMoreOptionsDropdown = !this.showMoreOptionsDropdown;
  }

  closeMoreOptionsDropdown() {
    this.showMoreOptionsDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Close dropdown when clicking outside
    const target = event.target as HTMLElement;
    if (!target.closest('.more-options-container')) {
      this.showMoreOptionsDropdown = false;
    }
  }

  // Navigation methods for dropdown items
  navigateToProfile() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile']);
  }

  navigateToOrders() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/orders']);
  }

  navigateToGarage() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/my-garage']);
  }

  navigateToAddresses() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/address']);
  }

  navigateToWishlist() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/wishlist']);
  }

  navigateToCoupons() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/coupons']);
  }

  navigateToNotifications() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/notification-alert']);
  }

  navigateToScrapCertificate() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/scrap-certificate']);
  }

  navigateToFAQ() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/profile-faq']);
  }

  navigateToCustomerSupport() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.router.navigate(['/user-profile/customer-support']);
  }

  handleLogout() {
    this.showMoreOptionsDropdown = false;
    this.closeSettingsPanel();
    this.showLogoutPopup = true;
  }

  // Method to manually refresh cart count (can be called from template or other places)
  refreshCartCount(): void {
    if (this.isLoggedIn) {
      this.fetchCartCount();
    } else {
    }
  }

  // Toggle mobile search input
  toggleMobileSearch() {
    this.isMobileSearchActive = !this.isMobileSearchActive;
    if (this.isMobileSearchActive) {
      // Focus the input after it's rendered
      setTimeout(() => {
        const mobileSearchInput = document.querySelector('#mobile-search-input') as HTMLInputElement;
        if (mobileSearchInput) {
          mobileSearchInput.focus();
        }
      }, 100);
    } else {
      // Close search popup when closing mobile search
      this.showSearchPopup = false;
      this.searchTerm = '';
    }
  }

  // Close mobile search
  closeMobileSearch() {
    this.isMobileSearchActive = false;
    this.showSearchPopup = false;
  }
}
